import PaginatedGanttChart from "PFApp/workflow/parts/paginated_gantt_chart";
import PropTypes from "prop-types";
import React from "react";

import AuditPlannerGantt from "./audit_planner_gantt";
import PaginatedExceptionsList from "./paginated_exceptions_list";

const ControlCentreTab = ({
  data,
  fetchData,
  showPlanner,
  tab,
  fetchAllEngagements,
  workflowAutomation,
  roleFilters
}) => (
  <div>
    {showPlanner ? (
      <PaginatedGanttChart data={data} fetch={fetchData} ganttComponent={AuditPlannerGantt} />
    ) : (
      <PaginatedExceptionsList
        data={data}
        fetchData={fetchData}
        tab={tab.id}
        fetchAllEngagements={fetchAllEngagements}
        workflowAutomation={workflowAutomation}
        roleFilters={roleFilters}
      />
    )}
  </div>
);

ControlCentreTab.propTypes = {
  data: PropTypes.shape({
    entries: PropTypes.arrayOf(PropTypes.object),
    meta: PropTypes.object,
    loading: PropTypes.bool
  }).isRequired,
  showPlanner: PropTypes.bool,
  tab: PropTypes.object.isRequired,
  fetchData: PropTypes.func.isRequired,
  fetchAllEngagements: PropTypes.func.isRequired,
  workflowAutomation: PropTypes.shape({
    auto_filling: PropTypes.number.isRequired,
    auto_shortlisting: PropTypes.number.isRequired,
    pending: PropTypes.number.isRequired
  }).isRequired,
  roleFilters: PropTypes.object
};

export default ControlCentreTab;
